import axios from "@/libs/request";

// 获取公告接口
export const affiche = (data) => axios.request({ url: "/game/notice/enter", data, unHint: true });
// 新游推荐接口
export const newGameList = (params) => axios.request({ url: "/game/sdk-float/new-game", params, method: 'get', unHint: true });
// 气泡推送
export const bubbleFication = (data) => axios.request({ url: "/bubbleFication", data, unHint: true });
// 获取悬浮窗礼包详情接口
export const giftDetail = (data) => axios.request({ url: "/activity/gift/detail", data, unHint: true });
// 获取礼包码
export const getGiftNum = (data) => axios.request({ url: "/activity/gift/num", data });

/* sdk红包部分 */
// 红包领取接口
export const getReceive = (data) => axios.request({ url: "/sdkPackets/receive", data }, 'sign');
// 红包信息接口
export const getReceiveInfo = (data) => axios.request({ url: "/sdkPackets/info", data, unHint: true }, 'sign');
// 红包钱包余额接口
export const getWalletInfo = (data) => axios.request({ url: "/sdkPackets/wallet/info", data }, 'sign');
// 提现接口
export const withDraw = (data) => axios.request({ url: "/sdkPackets/wallet/withdraw", data }, 'sign');
// 提现记录
export const withDrawRecord = (data) => axios.request({ url: "/sdkPackets/wallet/record", data }, 'sign');
// 获取提现金额列表
export const getWithdrawOptions = (data) => axios.request({ url: "/sdkPackets/wallet/withdrawOptions", data }, 'sign');
// 获取提现金额列表v2
export const getWithdrawOptionsV2 = (data) => axios.request({ url: "/sdkPackets/wallet/withdraw-options/v2", data });
// 游戏直冲接口
export const directRecharge = (data) => axios.request({ url: "/sdkPackets/wallet/recharge", data }, 'sign');
// 提现实名接口
export const authentication = (data) => axios.request({ url: "/sdkPackets/wallet/withdraw/authentication", data }, 'sign');

// v2版领取红包接口
export const getReceiveV2 = (data) => axios.request({ url: "/sdkPackets/v2/receive", data }, 'sign');
// v2版钱包余额接口
export const getWalletInfoV2 = (data) => axios.request({ url: "/sdkPackets/v2/wallet/info", data }, 'sign');
// v2版钱包提现选项接口
export const getWithdrawOptionsV3 = (data) => axios.request({ url: "/sdkPackets/v2/wallet/withdraw/options", data }, 'sign');
// v2版钱包提现接口
export const withDrawV2 = (data) => axios.request({ url: "/sdkPackets/v2/wallet/withdraw", data }, 'sign');
// v2版钱包提现接口
export const withDrawRecordV2 = (data) => axios.request({ url: "/sdkPackets/v2/wallet/withdraw/record", data }, 'sign');

// 绑定支付宝返回检查接口
export const checkALiBindResult = (data) => axios.request({ url: "/sdkPackets/wallet/withdraw/authentication/alipay", data, unHint: true }, 'sign');

/* sdk活动部分 */
// 获取sdk活动（h5使用，原生客户端调）
export const activityShow = (data) => axios.request({ url: "/activity/show", data, unHint: true });
// 获取活动信息接口
export const activityInfo = (data) => axios.request({ url: "/activity/info", data, unHint: true });
// 获取闪页信息接口
export const activityFlashInfo = (data) => axios.request({ url: "/activity/flashInfo", data, unHint: true });
// 在活动页面、闪页中点击按钮时上报
export const buttonReport = (data) => axios.request({ url: "/activity/buttonReport", data, unHint: true });
// 展示闪页时记录时长，闪页展示完毕时上报时长
export const flashReport = (data) => axios.request({ url: "/activity/flashReport", data, unHint: true });

/* 盒子sdk相关 */
// 盒子游戏判断是否广告推荐位
export const getBoxAdBanner = (params) => axios.request({ method: 'get', url: "/game/sdk-float/box/entrance-icon", params, unHint: true });

// 获取临时用户ID
export const getTempId = (data) => axios.request({ url: "/worker/token/tempId", data });